import {
  AddressAutoCompleteOption,
  ApiAdresseFeature,
  ApiAdresseResponse,
} from 'types/ApiAdresse';

const API_ADRESSE_BASE_URL = 'https://api-adresse.data.gouv.fr';

/**
 * Service for interacting with the French government's API Adresse
 * Documentation: https://adresse.data.gouv.fr/api-doc/adresse
 */
class ApiAdresseService {
  /**
   * Search for addresses using autocomplete
   * @param query - The search query (partial address)
   * @param limit - Maximum number of results (default: 5)
   * @returns Promise with autocomplete options
   */
  async searchAddresses(
    query: string,
    limit: number = 5,
  ): Promise<AddressAutoCompleteOption[]> {
    if (!query || query.trim().length < 3) {
      return [];
    }

    try {
      const params = new URLSearchParams({
        q: query,
        limit: limit.toString(),
        autocomplete: '1',
      });

      const response = await fetch(
        `${API_ADRESSE_BASE_URL}/search/?${params.toString()}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: ApiAdresseResponse = await response.json();

      return data.features.map((feature: ApiAdresseFeature) => {
        const props = feature.properties;
        return {
          value: props.label,
          label: props.label,
          address: props.name,
          postalCode: props.postcode,
          city: props.city,
          fullData: feature,
        };
      });
    } catch (error) {
      console.error('Error fetching addresses from API Adresse:', error);
      return [];
    }
  }
}

export const apiAdresseService = new ApiAdresseService();
